// Backend host configuration. Values come from Vite env (see .env.example),
// mirroring flutter_client assets/configs/config_*.json. The rider app talks to
// several hosts: the main API gateway, the maps cache proxy, and the pricing RPC.

type RuntimeConfig = Partial<{
  VITE_API_BASE_URL: string;
  VITE_CACHE_BASE_URL: string;
  VITE_RPC_BASE_URL: string;
  VITE_SOCKET_URL: string;
  VITE_BRANCH_ID: string;
  VITE_DEFAULT_COUNTRY: string;
  VITE_DEFAULT_CURRENCY: string;
  VITE_DEFAULT_LANGUAGE: string;
  VITE_MAP_STYLE_URL: string;
  VITE_MAPTILER_KEY: string;
  VITE_MAP_DEFAULT_LAT: string;
  VITE_MAP_DEFAULT_LON: string;
  VITE_ORDER_POLL_MS: string;
}>;

declare global {
  interface Window {
    __CARMA_TMA_CONFIG__?: RuntimeConfig;
  }
}

const runtime = window.__CARMA_TMA_CONFIG__ ?? {};

function env(name: keyof RuntimeConfig): string | undefined {
  return runtime[name] ?? import.meta.env[name];
}

function required(name: keyof RuntimeConfig, value: string | undefined): string {
  if (!value) {
    // Fail loud in dev; in prod the build should always inject these.
    console.error(`[config] Missing required env ${name}`);
  }
  return value ?? '';
}

export const config = {
  apiBaseUrl: required('VITE_API_BASE_URL', env('VITE_API_BASE_URL')),
  cacheBaseUrl: required('VITE_CACHE_BASE_URL', env('VITE_CACHE_BASE_URL')),
  rpcBaseUrl: env('VITE_RPC_BASE_URL') ?? '',
  socketUrl: env('VITE_SOCKET_URL') ?? '',

  branchId: Number(env('VITE_BRANCH_ID') ?? '2'),
  defaultCountry: env('VITE_DEFAULT_COUNTRY') ?? 'UA',
  defaultCurrency: env('VITE_DEFAULT_CURRENCY') ?? 'UAH',
  defaultLanguage: env('VITE_DEFAULT_LANGUAGE') ?? 'uk',

  mapStyleUrl: env('VITE_MAP_STYLE_URL') ?? 'https://demotiles.maplibre.org/style.json',
  maptilerKey: env('VITE_MAPTILER_KEY') ?? '',
  mapDefaultLat: Number(env('VITE_MAP_DEFAULT_LAT') ?? '50.4501'),
  mapDefaultLon: Number(env('VITE_MAP_DEFAULT_LON') ?? '30.5234'),

  orderPollMs: Number(env('VITE_ORDER_POLL_MS') ?? '3000'),
} as const;

// Gateway path prefixes on the main API host (see flutter_client app_urls.dart).
export const paths = {
  identity: '/identity',
  order: '/order',
  client: '/client',
  payment: '/payment',
} as const;
